import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LanguageConsumer, ThemeConsumer } from '../../state'
import styled from 'styled-components'
import Loader from '../Loader'
import Link from '../Link'

const Container = styled.div`
  width: 100%;

  @media screen and (max-width: ${({ theme }) =>
      theme.dimensions.screenSizes.medium - 1}px) {
    max-width: 40rem;
    display: block;
    margin: 0 auto;
  }
`

const LoaderContainer = styled.div`
  padding-top: 8rem;
  text-align: center;
`

const loaded = false
const loadScript = () => {
  if (loaded) return
  const tag = document.createElement('script')
  tag.async = true
  tag.defer = true
  tag.src = 'https://platform.twitter.com/widgets.js'
  document.body.appendChild(tag)
}

const ViewMore = styled.div`
  margin-top: 2rem;
  text-align: right;

  @media screen and (max-width: ${({ theme }) =>
      theme.dimensions.screenSizes.medium - 1}px) {
    text-align: center;
  }
`

const TwitterFeed = ({ timeline, viewMore }) => {
  useEffect(() => {
    loadScript()
  }, [])

  return (
    <LanguageConsumer>
      {({ lang }) => (
        <ThemeConsumer>
          {({ theme }) => (
            <Container>
              <a
                className="twitter-timeline"
                data-lang={lang}
                data-theme={theme.twitterFeed}
                data-link-color={theme.colors.interactive}
                data-chrome="noheader nofooter noborders transparent"
                data-tweet-limit="5"
                href={`https://twitter.com/${timeline}?ref_src=twsrc%5Etfw`}
              >
                <LoaderContainer>
                  <Loader />
                </LoaderContainer>
              </a>
              <ViewMore>
                <Link
                  tracking={{ label: `twitter_timeline_view_more_${timeline}` }}
                  href={`https://twitter.com/${timeline}`}
                >
                  {viewMore}
                </Link>
              </ViewMore>
            </Container>
          )}
        </ThemeConsumer>
      )}
    </LanguageConsumer>
  )
}

TwitterFeed.propTypes = {
  viewMore: PropTypes.string.isRequired,
  timeline: PropTypes.string.isRequired
}

export default TwitterFeed
